import { render, staticRenderFns } from "./HeaderSettings.vue?vue&type=template&id=092aabec&scoped=true&"
import script from "./HeaderSettings.ts?vue&type=script&lang=ts&"
export * from "./HeaderSettings.ts?vue&type=script&lang=ts&"
import style0 from "./HeaderSettings.vue?vue&type=style&index=0&id=092aabec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092aabec",
  null
  
)

export default component.exports